export interface IMenu {
	id: number;
	parentId: number;
	title: string;
	header: string;
	routerLink: string;
	href?: string;
	icon: string;
	target?: string;
	desc?: string;
	hasSubMenu?: boolean;
	isHorizontalMenu?: boolean;
	allowInFavoritesNav?: boolean;
	menuOrientation?: string;
	forceShow?: boolean;
	isHidden?: boolean;
	isRootModule?: boolean;
	menuLocation?: string;
}

export const defaultMenuId = 0;
export const landingPageMenuId = 1;

export interface IMessage {
	clientUniqueId: string;
	type: string;
	message: string;
	date?: Date;
}

export interface IVerifyCheckoutResponse {
	status: string;
}